export default "__VITE_ASSET__526c8b37__"